const ls = require("local-storage");

declare const __GAMENAME__: string;
declare const __VERSION__: string;

export class LocalStorage {

    public set(key: string, value: string | number | boolean) {
        if (value !== undefined) {
            ls.set(this.getUniqueKey(key), value);
        }
    }

    public getBoolean(key: string): boolean {
        return this.get(key) as boolean;

    }

    public getString(key: string): string {
        return this.get(key) as string;
    }

    public getNumber(key: string): number {
        return this.get(key) as number;
    }

    protected getUniqueKey(key: string) {
        if (typeof __VERSION__ !== "undefined") {
            key = __VERSION__ + "_" + key;
        }
        if (typeof __GAMENAME__ !== "undefined") {
            key = __GAMENAME__ + "_" + key;
        }

        return key;
    }

    private get(key: string): string | boolean | number {
        return ls.get(this.getUniqueKey(key));
    }
}
